export default __webpack_public_path__ + "static/media/partner-liefering.17bfb350.jpg";